export function isWindows(): boolean {
  return (
    window.navigator.userAgent.toLowerCase().includes('windows') ||
    (window.desktopIntegrations && window.desktopIntegrations.appInfo.os === 'Windows')
  );
}
